import { getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"

import { useStoredGoodsReceiptBuildPalletsColumns } from "./hooks/useStoredGoodsReceiptBuildPalletsColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface StoredGoodsReceiptPalletsTableProps {
  pallets: GoodsReceiptPallet[]
  isAkrochemManaged?: boolean
  isLoading?: boolean
  onQrPrint?: (pallet: GoodsReceiptPallet) => void
}

export const StoredGoodsReceiptBuiltPalletsTable: FC<StoredGoodsReceiptPalletsTableProps> = ({
  pallets,
  isAkrochemManaged = true,
  isLoading = false,
  onQrPrint,
}) => {
  const columns = useStoredGoodsReceiptBuildPalletsColumns({ isAkrochemManaged, onQrPrint })

  return (
    <AerosBaseTable<GoodsReceiptPallet>
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data: pallets,
          columns,
          enableSorting: false,
          getCoreRowModel: getCoreRowModel(),
          getRowId: (row) => row.goodsReceiptPalletId,
          state: { isLoading },
        },
      }}
      noDataMessage='No pallets found'
    />
  )
}
